module.exports = __webpack_public_path__ + "img/manual.27108df.svg";